import request from '@/utils/request'

// 作业能力列表页
export function apiGetWorkCapacity4plList (query) {
	return request({
		url: `/inv/invWorkCapacity4pl/list`,
		method: 'get',
		params: query
	})
}

// 导出列表
export function apiInvWorkCapacity4plNewExport (data) {
  return request({
    url: '/inv/invWorkCapacity4pl/v2/export',
    method: 'post',
    data: data
  })
}
